export default __webpack_public_path__ + "static/5-365a3a30039121b70f5937883aba1579.webp";